export const getUsuariosByCodEmpresas = async (api, codsEmpresas) => {
    const cods = (Array.isArray(codsEmpresas) ? codsEmpresas : [codsEmpresas])
        .filter((cod) => cod !== null && cod !== undefined && cod !== "");

    if (cods.length === 0) {
        return [];
    }

    const response = await api.post("/api/Usuario/GetUsuariosByCodEmpresas", cods);
    return response.data || [];
};

export const appendUsuariosNotificadosByEmpresa = async (
    formData,
    api,
    codsEmpresas
) => {
    const usuarios = await getUsuariosByCodEmpresas(api, codsEmpresas);
    const codUsuarios = usuarios
        .map((usuario) => usuario.codUsuario ?? usuario.CodUsuario)
        .filter((cod) => cod !== null && cod !== undefined && cod !== "");

    formData.append("DestinatariosNotificacion", 3);
    codUsuarios.forEach((codUsuario) => {
        formData.append("CodsUsuariosNotificados", codUsuario);
    });

    return codUsuarios;
};
